import type { ExternalDocument } from '../../types';

export const isExternalDocument = (entity: any): entity is ExternalDocument =>
	entity.__typename === 'ExternalDocument';

export const getExternalDocumentLink = (document: ExternalDocument): string | null =>
	document?.url ?? null;
